module.exports = __webpack_public_path__ + "img/banner_03.fb801c9a.png";